import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["list", "pagination"];

  load(event) {
    event.preventDefault();

    const button = event.currentTarget;
    if (button.dataset.loading === "true") {
      return;
    }

    button.dataset.loading = "true";

    fetch(button.href, { headers: { Accept: "text/plain" } })
      .then(response => response.text())
      .then((data) => {
        const template = document.createElement("template");
        template.innerHTML = data.trim();

        const nextList = template.content.querySelector('[data-load-more-helps-target="list"]');
        const nextPagination = template.content.querySelector('[data-load-more-helps-target="pagination"]');

        if (nextList) {
          Array.from(nextList.children).forEach((child) => {
            this.listTarget.appendChild(child);
          });
        }

        if (nextPagination) {
          this.paginationTarget.outerHTML = nextPagination.outerHTML;
        } else if (this.hasPaginationTarget) {
          this.paginationTarget.remove();
        }
      })
      .finally(() => {
        button.dataset.loading = "false";
      });
  }
}
